import { render, staticRenderFns } from "./Test41.vue?vue&type=template&id=53095ad3&"
import script from "./Test41.vue?vue&type=script&lang=js&"
export * from "./Test41.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports